import { render, staticRenderFns } from "./DefectTypeModal.vue?vue&type=template&id=4bd1383c&scoped=true"
import script from "./DefectTypeModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefectTypeModal.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd1383c",
  null
  
)

export default component.exports